//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fileUploader from '../../views/common-components/file-uploader';
import util from '@/lib/util';
import draggable from 'vuedraggable';

export default {
    name: 'albumsDetail',
    components: {
        fileUploader, draggable
    },
    data() {
        return {
            loading: false,
            showEditPhotoModel: false,
            album: {
                delAttrIds: [],
                addAttIds: []
            },
            rules: {
                content: [{ required: true, message: '请输入内容', trigger: 'blur' }],
                tag: [{ required: true, message: '请选择标签', trigger: 'blur' }]
            },
            tags: ['亲子', '旅游', '家园', '物业', '运动', '美景'],
            saving: false,
            pageSize: 8,
            pageIndex: 1,
            totalCount: 0,
            searchInput: {},
            list: [],
            downloadUrl: util.ApiUrl + '/file/download/',
            onFetching: false,
            albumId: 0,
            currentImages: []
        };
    },
    methods: {
        editPhoto(p) {
            // this.album = p;
            this.album.file = { associateType: 'AlbumImage' };
            this.showEditPhotoModel = true;
        },
        cancel() {
            this.showEditPhotoModel = false;
        },
        save() {
            if (typeof (this.album.addAttIds) == 'undefined') {
                this.$Notice.warning({
                    title: '提示',
                    desc: '请选择照片'
                });
                // this.loading = false;
                return false;
            }
            // this.$refs.albumForm.validate(async (val) => {
            //     if (val) {
            this.saving = true;
            abp.ajax.post('/api/services/app/Album/SaveAlbum', this.album).then(
                (resp) => {
                    this.getAlbum();
                    // this.saving = false;
                    this.showEditPhotoModel = false;
                }, (error) => {
                    this.saving = false;
                }).finally(() => {
                this.saving = false;
            });
            // }
            // });
        },
        scrollLoad() {
            let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight; //document的滚动高度
            let nowScotop = document.documentElement.clientHeight || document.body.clientHeight;  //可视区高度
            let wheight = document.documentElement.scrollTop || document.body.scrollTop; //已滚动高度
            if (this.onFetching) {
                // do nothing
                // console.log('333');
            } else {
                if (nowScotop >= scrollHeight - wheight - 5) {
                    this.onFetching = true;
                    setTimeout(() => {

                        this.pageIndex += 1;
                        this.getPage(); //加载列表的请求方法
                        this.onFetching = false;
                    }, 500);
                }
            }
        },
        delPhoto(row) {
            const vm = this;
            this.album.delAttrIds.push(row.id);
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认删除吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {
                    abp.ajax.post('/api/services/app/Album/SaveAlbum', this.album).then(
                        (resp) => {
                            this.getAlbum();
                            // this.saving = false;
                            this.showEditPhotoModel = false;
                        }, (error) => {
                            this.saving = false;
                        });

                }
            });
        },
        getAlbum() {
            this.loading = true;
            abp.ajax.get('/api/services/app/Album/GetAlbumById?id=' + this.albumId).then((resp) => {
                this.album = resp.data.result;
                this.currentImages = this.album.images;
            }).finally(() => {
                this.loading = false;
            });
        },
        uploadAfter(f) {
            // console.log('-------------------------');
            // console.log(f);
        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        },
        saveSort() {
            var d = {};
            d.images = [];
            d.images = this.album.images;
            this.loading = true;
            abp.ajax.post('/api/services/app/Album/SaveAlbumSort', d).then((resp) => {
                this.getAlbum();
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    mounted() {
        // let _this = this;
        // // 设置一个开关来避免重负请求数据
        // let sw = true;
        // window.document.addEventListener('scroll', _this.scrollLoad, true);
    },
    created() {
        this.albumId = parseInt(this.$route.params.id) || 0;
        this.getAlbum();
    },
    updated() {
    },
    watch: {}
};
